import { Component, OnInit, Input } from '@angular/core';
import { IHeaderCell } from '../../../holders/header-cell.component';
import { Col } from '../../../../utility/cols/col.class';

@Component({
   selector: 'app-selector-all',
   template: `
      <button class="checkbox" (click)="toggleAll()">
         <div class="horiz"></div>
         <div class="vert" *ngIf="!col.ctx.selection.isSomeSelected"></div>
      </button>
   `,
   styleUrls: ['./selector-all.component.scss']
})
export class SelectorAllHeaderCellComponent implements IHeaderCell, OnInit {
   @Input() col: Col<object>;


   ngOnInit() {

   }

   public toggleAll() {
      if (this.col.ctx.selection.isSomeSelected ) {
         this.col.ctx.selection.unselectAll();
      } else {
         this.col.ctx.selection.selectAll();
      }
      this.col.ctx.selection.select(null);
   }
}